// extracted by mini-css-extract-plugin
export default {"root":"FreemiumFeaturesList__root--ibobS","item":"FreemiumFeaturesList__item--2mE2f"};